import { Button } from '@salt/components';
import React, { useCallback } from 'react';
import { removeUser } from '../../api/users';

const RemoveUserModal = ({ handleRemoveUserModalClose, user, project, fetchData }) => {
  const onRemove = useCallback(() => {
    removeUser({ projectId: project.id, memberId: user.id })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to remove user');
      });
    handleRemoveUserModalClose();
  }, [user, project]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleRemoveUserModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="text-lg mb-4">Remove User</div>
        <span className="text-base">
          Are you sure you want to remove <b>{user.name}</b>?
        </span>

        <div className="mt-4">
          <br />
          <Button
            onClick={handleRemoveUserModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={onRemove}
            type="negative"
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RemoveUserModal;
